import React, { useContext, useEffect } from 'react';
import { registerStickyFilter } from '@fiverr-private/listing_lib';
import { BusinessListingPropTypes } from '../../types/index';
import { LISTING_TYPE } from '../../utils/constants';
import { isSearchResultsFlow } from '../../utils/flowUtils';
import { useCountFlowAndListingTypeView } from '../../hooks';
import { AppContext } from '../context/listingsContext';
import { ProfessionCategoryHeader, ProfessionCategoryContent } from '../profession_category';
import { BusinessLayout, BusinessListingsProvider, ItemsContainer, Sidebar } from './BusinessPageLayout';
import BusinessGigsGridListing from './BusinessGigsGridListing';

export const BusinessGigsListing = (props) => {
    const { flow, breadcrumbs, managedAccount, rollouts, isProfessionCategory = false, seoData } = props;

    const {
        listings: [listings],
        activeFilters,
        categoryIds,
        dominateSubCategoryId,
        significantLeafCategories = [],
        displayQuery,
        appFilters,
        pagination,
        displayData,
        isFallbackFromExpertListings,
    } = useContext(AppContext);

    useEffect(() => {
        registerStickyFilter(activeFilters);
    }, [activeFilters]);

    let searchTitleData;
    const isSearch = isSearchResultsFlow(flow);

    if (isSearch) {
        const {
            searchComponentData: { modifiedQueryString, nonTranslatedQuery, searchInsteadUrl, query },
        } = displayData;

        searchTitleData = { modifiedQueryString, nonTranslatedQuery, searchInsteadUrl, translatedQuery: query };
    }

    const { filters, visualFilters, selectedFilters, subCategory = {} } = appFilters;
    const { gigs } = listings;
    const { header } = displayData;
    const subcategoryName = header?.title;

    // Using hasGigs is a temporary workaround since currently we get 1 result for gigs when there are none
    const hasGigs = gigs.length > 0;
    const resultsCount = !hasGigs ? 0 : pagination?.total;

    useCountFlowAndListingTypeView(flow, LISTING_TYPE.GIGS);

    return (
        <BusinessListingsProvider
            rollouts={rollouts}
            resultsCount={resultsCount}
            isExpertListings={false}
            isFallbackFromExpertListings={!!isFallbackFromExpertListings}
            isSearch={isSearch}
            isProfessionCategory={isProfessionCategory}
            filters={filters}
            activeFilters={activeFilters}
            visualFilters={visualFilters}
            selectedFilters={selectedFilters}
            subCategory={subCategory}
            subcategoryName={subcategoryName}
            breadcrumbs={breadcrumbs}
            hasItems={hasGigs}
            categoryIds={categoryIds}
            dominateSubCategoryId={dominateSubCategoryId}
            significantLeafCategories={significantLeafCategories}
            displayQuery={displayQuery}
            searchQueryData={searchTitleData}
            managedAccount={managedAccount}
        >
            {isProfessionCategory && <ProfessionCategoryHeader seoData={seoData} />}
            <BusinessLayout>
                <Sidebar />
                <ItemsContainer>
                    <BusinessGigsGridListing />
                </ItemsContainer>
            </BusinessLayout>
            {isProfessionCategory && <ProfessionCategoryContent seoData={seoData} />}
        </BusinessListingsProvider>
    );
};

BusinessGigsListing.propTypes = BusinessListingPropTypes;
